/**
 * Shared module.
 * 
 * @author Giulio Montagner
 * @version 1.0.0
 * @since 13th August 2017
 * @export
 * @class SharedModule
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
// import { DndModule } from 'ng2-dnd';
import { NgMathPipesModule, NgArrayPipesModule } from 'angular-pipes';

// Components
import { LoadableComponent } from './components/loadable-component/loadable.component';
import { MyLoadableComponent } from './components/my-loadable-component/my-loadable.component';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
// import { WysiwygEditorComponent } from './components/wysiwyg-editor/wysiwyg-editor.component';
// import { WysiwygEditorNewsletterComponent } from './components/wysiwyg-editor/wysiwyg-editor-newsletter.component';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { SingleselectComponent } from './components/singleselect/singleselect.component';
// import { TagselectComponent } from './components/tagselect/tagselect.component';
// import { FileUploadComponent } from './components/file-upload/fileupload.component';
// import { DateTimePickerComponent } from './components/datetimepicker/datetimepicker.component';
// import { DatePickerComponent } from './components/datepicker/datepicker.component';
// import { NumberSpinnerComponent } from './components/number-spinner/number-spinner.component';
// import { ContentSelectorCollapsableComponent } from './components/content-selector-picker/content-selector-collapsable.component';
// import { ContentSelectorPickerComponent } from './components/content-selector-picker/content-selector-picker.component';
// import { AttachmentSelectorPickerComponent } from './components/attachment-selector-picker/attachment-selector-picker.component';
// import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
// import { ImageFileCropperComponent } from './components/image-file-cropper/image-file-cropper.component';
import { ListViewComponent } from './components/listview/listview.component';
// import { AttachmentLoaderComponent } from './components/content-selector-picker/attachment-loader.component';
// import { FileDropInterceptor } from './components/file-drop-interceptor/file-drop-interceptor.component';
// import { FileDropCropperComponent } from './components/file-drop-interceptor/file-drop-cropper.component';
// import { DragAreaComponent } from './components/drag-area/drag-area.component';
// import { FileDropModule } from 'angular2-file-drop';
// import { DataTableComponent } from './components/data-table/data-table.component';
// import { ContentEditingPropertyComponent } from './components/content-editing-property/content-editing-property.component';
// import { CropperComponent } from './components/cropper/cropper.component';
// import { TreeBrowserComponent } from './components/tree-browser/tree-browser.component';
// import { ContentActionSelectorComponent } from './components/content-action-selector/content-action-selector.component';
// import { ReportTemplatePickerComponent } from './components/report-template-picker/report-template-picker.component';
// Pipes
import { IterableObjectPipe } from './pipes/iterable-object.pipe';
import { GroupArrayPipe } from './pipes/group-array.pipe';
import { RenderableItemsFilterPipe } from './pipes/renderable-items-filter.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TranslatePipe } from './pipes/translate.pipe';

// Directives
import { RightSidebarDirective } from './directives/right-sidebar.directive';
import { ACLDirective } from './directives/acl.directive';
import { BreadcrumbsComponent } from '../components/breadcrumbs/breadcrumbs.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // PrimeNG
    // AutoCompleteModule,
    // DialogModule,
    // TreeModule,
    // DataTableModule,
    // DataGridModule,
    // PrimeNgSharedModule,
    // PanelModule,
    // PaginatorModule,
    // ButtonModule,
    // DropdownModule,
    // SpinnerModule,
    // InputSwitchModule,
    // RadioButtonModule,
    // MultiSelectModule,
    // NgBootstrap
    // NgbModule.forRoot(),
    //  FileDropModule,
    // DndModule.forRoot(),
    NgMathPipesModule,
    NgArrayPipesModule
  ],
  declarations: [
    LoadableComponent,
    BreadcrumbsComponent,
    MyLoadableComponent,
    MessageBoxComponent,
    ToolbarComponent,
    // WysiwygEditorComponent,
    // WysiwygEditorNewsletterComponent,
    MultiselectComponent,
    SingleselectComponent,
    // TagselectComponent,
    // FileUploadComponent,
    // DateTimePickerComponent,
    // DatePickerComponent,
    IterableObjectPipe,
    GroupArrayPipe,
    RenderableItemsFilterPipe,
    CapitalizePipe,
    SafeHtmlPipe,
    TranslatePipe,
    // NumberSpinnerComponent,
    // ContentSelectorCollapsableComponent,
    // ContentSelectorPickerComponent,
    // AttachmentSelectorPickerComponent,
    // ImageCropperComponent,
    // ImageFileCropperComponent,
    ListViewComponent,
    // AttachmentLoaderComponent,
    // FileDropInterceptor,
    // FileDropCropperComponent,
    // DragAreaComponent,
    // DataTableComponent,
    // ContentEditingPropertyComponent,
    // CropperComponent,
    RightSidebarDirective,
    ACLDirective,
    // TreeBrowserComponent,
    // ContentActionSelectorComponent,
    // ReportTemplatePickerComponent
  ],
  exports: [
    // Imports
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // AutoCompleteModule,
    // DialogModule,
    // TreeModule,
    // DataTableModule,
    // DataGridModule,
    // PrimeNgSharedModule,
    // PanelModule,
    // PaginatorModule,
    // SpinnerModule,
    // ButtonModule,
    // DropdownModule,
    // NgbModule,
    // FileDropModule,
    // InputSwitchModule,
    // RadioButtonModule,
    // MultiSelectModule,
    NgMathPipesModule,
    NgArrayPipesModule,
    // Declarations
    BreadcrumbsComponent,
    LoadableComponent,
    MyLoadableComponent,
    MessageBoxComponent,
    ToolbarComponent,
    // WysiwygEditorComponent,
    // WysiwygEditorNewsletterComponent,
    MultiselectComponent,
    SingleselectComponent,
    // TagselectComponent,
    // FileUploadComponent,
    // DateTimePickerComponent,
    // DatePickerComponent,
    IterableObjectPipe,
    GroupArrayPipe,
    RenderableItemsFilterPipe,
    CapitalizePipe,
    SafeHtmlPipe,
    TranslatePipe,
    // NumberSpinnerComponent,
    // ContentSelectorCollapsableComponent,
    // ContentSelectorPickerComponent,
    // AttachmentSelectorPickerComponent,
    // ImageCropperComponent,
    // ImageFileCropperComponent,
    ListViewComponent,
    // AttachmentLoaderComponent,
    // FileDropInterceptor,
    // FileDropCropperComponent,
    // DragAreaComponent,
    // DataTableComponent,
    // ContentEditingPropertyComponent,
    // CropperComponent,
    RightSidebarDirective,
    ACLDirective,
    // TreeBrowserComponent,
    // DndModule,
    // ContentActionSelectorComponent,
    // ReportTemplatePickerComponent
  ],
  entryComponents: [
    MessageBoxComponent,
    // FileDropInterceptor
  ]
})
export class SharedModule { }
